export default {
  RESEND: 'Resend report',
  REMOVE: 'Remove access',
}


// WEBPACK FOOTER //
// ./src/components/enums/ShareAction.js